import { createSlice } from "@reduxjs/toolkit";



const getOrgIdFromLocal = (key) => {
    const org_id = localStorage.getItem(key);
    if(org_id && org_id.trim()){
        return org_id;
    }
    return null;
}
const initialState = {
    name: "",
    email: "",
    contact: "",
    profile: "",
    department: "",
    org_id: getOrgIdFromLocal("current_org_id"),
    org_admin_id: localStorage.getItem("org_admin_id") || null
}

export const userSlice = createSlice({
    name: "userSlice",
    initialState,
    reducers: {
        updateUserData:(state , action)=>{
            const { name, email, contact, profile, department, org_id } = action.payload;
            if(name) state.name = name;
            if(email) state.email = email;
            if(contact) state.contact = contact;
            if(profile) state.profile = profile;
            if(department) state.department = department;
            if(org_id) state.org_id = org_id;
        },
        updateCurrentOrgId:(state,action)=>{
            const {org_id, org_admin_id} = action.payload;
            if(!org_id){
                console.log("Org Id Not Recived In updateCurrentOrgId Dispatch Returning...");
                return;
            }
            state.org_id = org_id;
            localStorage.setItem("current_org_id",org_id);
            if(org_admin_id){
                state.org_admin_id = org_admin_id;
                localStorage.setItem("org_admin_id", org_admin_id);
            }
        },
        clearUserSlice:(state)=>{
            state.name = "";
            state.email = "";
            state.contact = "";
            state.profile = "";
            state.department = "";
            state.org_id = null;
            state.org_admin_id = null;
            localStorage.removeItem("current_org_id");
            localStorage.removeItem("org_admin_id");
        }
    }
})

export const { updateUserData , updateCurrentOrgId , clearUserSlice} = userSlice.actions;
